import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Banner, ButtonLink } from '@blueprint/ui';
import { LSRP_SIDEBAR_MEDIA_QUERY } from 'search/common/constants';

export const StyledBanner = styled(Banner)((props) => {
    const {
        theme: { spacing, mq }
    } = props;
    const padding = `${spacing['16px']} ${spacing['24px']}`;
    return css`
        margin-top: ${spacing['24px']};
        margin-bottom: ${spacing['48px']};
        padding: ${padding};
        ${mq.medium} {
            padding: ${padding};
        }
        ${mq.large} {
            padding: ${padding};
        }
        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            margin: 0;
        }
    `;
});

export const BannerLinkContainer = styled('div')(
    (props) => css`
        margin-top: ${props.theme.spacing['16px']};
    `
);

export const BannerLink = styled(ButtonLink)(
    (props) => css`
        margin-right: ${props.theme.spacing['16px']};
        padding: 0;
        font-size: ${props.theme.fontSizes[1]};
    `
);

export const CloseButtonStyle = styled('button')(
    (props) => css`
        appearance: none;
        border: none;
        background-color: transparent;
        padding: 0;
        position: absolute;
        top: ${props.theme.spacing['16px']};
        right: ${props.theme.spacing['16px']};
        cursor: pointer;
    `
);
